/**
 * True when a scroll container is within `threshold` px of its bottom. Pure so
 * the inbox thread's stick-to-bottom logic is unit-testable without a layout
 * engine.
 */
export function isNearBottom(
  scrollHeight: number,
  scrollTop: number,
  clientHeight: number,
  threshold = 80,
): boolean {
  return scrollHeight - scrollTop - clientHeight <= threshold
}
